// lint-allow-file: colour (these are the data of the presets, not styling)
/** Eight starting colours for an agency brand, close to what logos on shop boards use. */
export const BRAND_PRESETS = [
  { key: 'teal', hex: '#0F766E' },
  { key: 'indigo', hex: '#4338CA' },
  { key: 'crimson', hex: '#B91C1C' },
  { key: 'orange', hex: '#C2410C' },
  { key: 'green', hex: '#15803D' },
  { key: 'purple', hex: '#7E22CE' },
  { key: 'blue', hex: '#1D4ED8' },
  { key: 'gold', hex: '#A16207' },
] as const;

const HEX = /^#[0-9a-fA-F]{6}$/;

/** What a person typed in the colour box, as `#RRGGBB`, or null when it is not a colour yet. */
export function normaliseColour(input: string): string | null {
  const trimmed = input.trim();
  const withHash = trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
  if (HEX.test(withHash)) return withHash.toUpperCase();
  const short = /^#([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])$/.exec(withHash);
  if (short === null) return null;
  return `#${short[1]}${short[1]}${short[2]}${short[2]}${short[3]}${short[3]}`.toUpperCase();
}

/** The CSS custom properties of a role map, named as the kit and the server HTML name them. */
export function roleVariables(roles: Record<string, string>): Record<string, string> {
  return Object.fromEntries(
    Object.entries(roles).map(([name, value]) => [
      name.startsWith('x-') ? `--${name}` : `--md-sys-color-${name}`,
      value,
    ]),
  );
}
